import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { FaAccessibleIcon } from 'react-icons/fa';
import { formLabel } from '../../../_elements/formLabel';
import formInput from '../../../_elements/formInput';

function ChannelAccessibilityInformationSection({ register }) {
    const [showAccessibility, setShowAccessibility] = useState(false);

    return (
        <>
            <div style={{ marginTop: 16, marginBottom: 8 }}>
                <div
                    onClick={() => setShowAccessibility(!showAccessibility)}
                    style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        padding: '8px 0',
                        borderBottom: '1px solid #eee',
                    }}
                >
                    <FaAccessibleIcon />
                    <span style={{ fontWeight: 600 }}>Accessibility Information</span>
                    <span style={{ marginLeft: 'auto', color: '#999' }}>{showAccessibility ? '−' : '+'}</span>
                </div>
            </div>

            {showAccessibility && (
                <div style={{ marginTop: 8 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                        <Form.Check
                            type="checkbox"
                            label="Wheelchair Accessible"
                            name="accessibility.wheelchairAccessible"
                            ref={register}
                        />
                        <Form.Check
                            type="checkbox"
                            label="Accessible Restroom"
                            name="accessibility.accessibleRestroom"
                            ref={register}
                        />
                        <Form.Check
                            type="checkbox"
                            label="Accessible Parking"
                            name="accessibility.accessibleParking"
                            ref={register}
                        />
                        <Form.Check
                            type="checkbox"
                            label="Elevator Available"
                            name="accessibility.elevatorAvailable"
                            ref={register}
                        />
                    </div>

                    <Form.Group>
                        <Form.Label css={formLabel}>Entrance Information</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="Describe entrance accessibility (ramps, doors, etc.)"
                            name="accessibility.entranceInfo"
                            ref={register}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label css={formLabel}>Elevator Information</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="Describe elevator details"
                            name="accessibility.elevatorInfo"
                            ref={register}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label css={formLabel}>Accessible Restrooms</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="Describe accessible restroom locations and features"
                            name="accessibility.accessibleRestrooms"
                            ref={register}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label css={formLabel}>Building Information</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="General building accessibility info"
                            name="accessibility.buildingInfo"
                            ref={register}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label css={formLabel}>Lactation Room</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="Lactation room details"
                            name="accessibility.lactationRoom"
                            ref={register}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label css={formLabel}>Parking Info</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="Accessible parking details"
                            name="accessibility.parkingInfo"
                            ref={register}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label css={formLabel}>Additional Notes</Form.Label>
                        <Form.Control
                            css={formInput}
                            as="textarea"
                            rows={2}
                            placeholder="Any other accessibility information"
                            name="accessibility.additionalNotes"
                            ref={register}
                        />
                    </Form.Group>
                </div>
            )}
        </>
    );
}

export default ChannelAccessibilityInformationSection;
